function formatEvent(event) {
  return event?.replace(/\./g, '_') || event;
}

export default formatEvent;
